import React, { useState } from 'react';
import { useStyles } from './CollapsibleProjectRoleInfoStyles';
import Tabs from './Tabs/Tabs';
import { IAuditionScheduleAttributes } from 'shared/interfaces/IAuditionSchedule';
import LocationAndDates from './Role/LocationAndDates/LocationAndDates';
import { Accordion, AccordionDetails, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { CustomTypography } from 'shared/elements/CustomTypography';

type Props = {
  auditionSchedule: IAuditionScheduleAttributes | undefined;
  isST?: boolean;
};

const CollapsibleProjectRoleInfo: React.FC<Props> = ({ auditionSchedule, isST }) => {
  const classes = useStyles();

  const AsyncProject = React.lazy(() => import('./Project'));
  const AsyncRole = React.lazy(() => import('./Role'));
  const [isShootingDaysExpanded, setIsShootingDaysExpanded] = useState(true);
  const [isRoleExpanded, setIsRoleExpanded] = useState(true);
  const [isProjectExpanded, setIsProjectExpanded] = useState(true);

  return (
    <div className={classes.root}>
      {/* {isSelftTapes ? (
        <React.Fragment />
      ) : ( */}
      <div className={classes.contentMain}>
        <Accordion
          expanded={isShootingDaysExpanded}
          onChange={() => setIsShootingDaysExpanded(!isShootingDaysExpanded)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1shootingdates-content"
            className={classes.accordionSummary}
            id="panel1shootingdates-header"
          >
            <CustomTypography fontSize={18} fontWeight={500}>
              Shooting Dates
            </CustomTypography>
          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.content}>
              <LocationAndDates
                isST={isST}
                data={
                  auditionSchedule && auditionSchedule.audition && auditionSchedule.audition.casting_role
                    ? auditionSchedule.audition.casting_role
                    : undefined
                }
              />
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
      {/* )} */}
      <div className={classes.contentMain}>
        <Accordion expanded={isRoleExpanded} onChange={() => setIsRoleExpanded(!isRoleExpanded)}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1shootingdates-content"
            className={classes.accordionSummary}
            id="panel1shootingdates-header"
          >
            <CustomTypography fontSize={18} fontWeight={500}>
              Role Information
            </CustomTypography>
          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.content}>
              <AsyncRole
                data={
                  auditionSchedule && auditionSchedule.audition && auditionSchedule.audition.casting_role
                    ? auditionSchedule.audition.casting_role
                    : undefined
                }
              />
            </div>
          </AccordionDetails>
        </Accordion>
      </div>

      <div className={classes.contentMain}>
        <Accordion expanded={isProjectExpanded} onChange={() => setIsProjectExpanded(!isProjectExpanded)}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1shootingdates-content"
            className={classes.accordionSummary}
            id="panel1shootingdates-header"
          >
            <CustomTypography fontSize={18} fontWeight={500}>
              Project Information
            </CustomTypography>
          </AccordionSummary>
          <AccordionDetails>
            <div className={classes.content}>
              <AsyncProject
                data={
                  auditionSchedule && auditionSchedule.audition && auditionSchedule.audition.casting_role
                    ? auditionSchedule.audition.casting_role
                    : undefined
                }
              />
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default CollapsibleProjectRoleInfo;
